{
  "+ 1h": "+ 1ч",
  "- 1h": "- 1ч",
  "A dataset": "Скуп података",
  "A post": "Објава",
  "A reuse": "Пример употребе",
  "A set of boolean parameters to toggle": "Сет логичких параметара",
  "A set of filters to apply": "Сет филтера",
  "A topic": "Тема",
  "A user": "Корисник",
  "API Key": "API кључ",
  "About": "Основни подаци",
  "Accept": "Прихвати",
  "Accepted": "Прихваћено",
  "Acronym": "Акроним",
  "Active": "Активно",
  "Add": "Додај",
  "Add a comment": "Додај коментар",
  "Add a filter": "Додај филтер",
  "Add a resource": "Додајте ресурс",
  "Add some related datasets": "Додајте неке повезане скупове података",
  "Add some related reuses": "Додајте неке повезане примере употребе",
  "Add your first resources": "Додај свој први ресурс",
  "All your resources looks to be directly available. That is great!": "Изгледа да су сви ваши ресурси директно доступни. То је сјајно!",
  "An error occured": "Дошло је до грешке",
  "An error occured while submitting your comment": "Дошло је до грешке приликом прослеђивања вашег коментара",
  "An error {status} occured": "Десила се грешка {status}",
  "An harvester": "Харвестер",
  "An organization": "Организација",
  "An unkown error occured": "Дошло је до интерне грешке",
  "Apply": "Примени",
  "Archived": "Архивирано",
  "Are you sure ?": "Да ли сте сигурни?",
  "Are you sure you want to delete this comment?": "Сигурни сте да желите да обришете овај коментар?",
  "Are you sure?": "Да ли сте сигурни?",
  "As administrator you can choose any organization to publish": "Као администратор, можете одабрати било коју организацију за објављивање",
  "Attention": "Пажња",
  "Automatic archiving": "Аутоматско архивирање",
  "Availability": "Доступност",
  "Availability of your datasets": "Доступност скупова података",
  "Backend": "Позадинска компонента",
  "Badges": "Беџеви",
  "Between": "Између",
  "Bold": "Подебљано",
  "Both dates are required": "Оба датума су обавезна",
  "Cancel": "Откажи",
  "Center the full picture": "Центрирајте целу слику",
  "Certified public service": "Сертификовани јавни сервис",
  "Change password": "Промените лозинку",
  "Changes saved": "Измене сачуване",
  "Checksum": "Контролни збир",
  "Choose under which identity you want to publish": "Изаберите под којим идентитетом желите да објавите",
  "Choose who is harvesting": "Изаберите ко преузима",
  "Choose who is publishing": "Изаберите ко објављује",
  "Clear": "Обриши",
  "Click the button to copy the whole code within your clipboard": "Копирај у меморију",
  "Close": "Затвори",
  "Closed on": "Затворено",
  "Comment": "Коментар",
  "Comment and close discussion": "Коментаришите и затворите дискусију",
  "Comment the discussion": "Коментаришите дискусију",
  "Communicate about your publication": "Комуникација о публикацији",
  "Community resources": "Ресурси заједнице",
  "Configure your harvester": "Конфигуришите харвестер",
  "Confirm": "Потврдите",
  "Confirm deletion": "Потврдите брисање",
  "Confirm refusal": "Потврдите одбијање",
  "Confirm restore": "Поништи брисање",
  "Content": "Садржај",
  "Copy-paste this code within your own HTML at the place you want the current dataset to appear:": "Копирајте и налепите овај кôд у свој HTML, тамо где желите да се појави тренутни скуп података:",
  "Created at": "Направљено у",
  "Created on": "Направљено:",
  "Creation": "Креирање",
  "Dashboard": "Контролна табла",
  "Data": "Подаци",
  "Daily": "Дневно",
  "Data update": "Ажурирање података",
  "Dataset": "Скуп података",
  "Datasets": "Скупови података",
  "Datasets-total": "сетова укупно",
  "Datasets (only yours)": "Скупови података (само ваши)",
  "Datasets as CSV": "Скупови података као CSV",
  "Datasets resources as CSV": "Ресурси скупова података као CSV",
  "Date": "Датум",
  "Date should be after start date": "Датум би требало да буде после датума почетка",
  "Delete": "Избриши",
  "Delete comment": "Избриши коментар",
  "Delete profile": "Избриши профил",
  "Deleted": "Избрисано",
  "Describe your community resource": "Опишите свој ресурс заједнице",
  "Describe your dataset": "Опишите свој скуп података",
  "Describe your organization": "Опишите своју организацију",
  "Describe your reuse": "Опишите пример употребе",
  "Description": "Опис",
  "Details": "Детаљи",
  "Discussing with the community about your datasets is key to involve developers and hackers in your open process. The feedback from reusers of your data is unvaluable and should be answered rather quickly.": "Дискусија са заједницом о скуповима података кључна је за увођење програмера у ваш отворени процес. Повратне информације од корисника података неизмерно су важне и требало би што пре одговорити на њих.",
  "Discussion": "Дискусија",
  "Discussion has been closed": "Дискусија је затворена",
  "Discussions": "Дискусије",
  "Discussions about your data (including your organizations)": "Разговори о подацима (укључујући и вашу организацију)",
  "Do you confirm the transfer of": "Да ли потврђујете пренос",
  "Done": "Готово",
  "Done with errors": "Готово са грешкама",
  "Downloads": "Преузимања",
  "Drag a file here": "Превуците датотеку овде",
  "Drag a picture here": "Превуците слику овде",
  "Drop resource": "Отпустите ресурс",
  "Due to security reasons, the creation of new content is currently disabled.": "Креирање новог садржаја је тренутно онемогућено услед сигуросних разлога.",
  "Edit": "Измени",
  "Edit dataset \"{title}\"": "Измени сет података \"{title}\"",
  "Edit harvest source \"{name}\"": "Ажурирај прикупљач \"{name}\"",
  "Edit organization \"{name}\"": "Измени организацију \"{name}\"",
  "Edit post \"{name}\"": "Измени пост \"{name}\"",
  "Edit profile": "Измени профил",
  "Edit reuse \"{title}\"": "Измени пример употребе \"{title}\"",
  "Edit the profile": "Измени профил",
  "Edit this dataset": "Измени податке",
  "Edit this organization": "Измени Организацију",
  "Edit this reuse": "Измени ово поновно коришћење",
  "Edit this user": "Измени ово поновно коришћење",
  "Edit topic \"{name}\"": "Измени тему \"{name}\"",
  "Edit user": "Измени корисника",
  "Editorial": "Уредништво",
  "End": "Крај",
  "End date should be after start date": "Датум завршетка би требало да буде после датума почетка",
  "Ended at": "Завршава се у",
  "Ensure your organization does not exists": "Уверите се да ваша организација не постоји",
  "Errors": "Грешке",
  "Exclude": "Искључи",
  "Expected update": "Очекивано ажурирање",
  "Explain why you request this transfer": "Објасните зашто тражите овај пренос",
  "Explain your response": "Објасните свој одговор",
  "Explain your validation": "Објасните валидацију",
  "Failed": "Није успело",
  "Feature this content": "Истакни овај садржај",
  "Featured": "Истакнуто",
  "Featured datasets": "Одабрани скупови података",
  "Featured reuses": "Истакнуте употребе",
  "Features": "Могућности",
  "Filters": "Филтери",
  "Find or create your organization": "Пронађите или направите своју организацију",
  "Find your dataset": "Пронађите свој скуп података",
  "Find your reuse": "Пронађите пример употребе",
  "Finish": "Заврши",
  "First name": "Име",
  "First page": "Прва страница",
  "Follow": "Прати",
  "Follower": "Пратилац",
  "Followers": "Пратиоци",
  "Followers (only yours)": "Пратиоци (само ваши)",
  "Format": "Формат",
  "Frequency": "Фреквенција",
  "Generate an API KEY": "Генерисање API кључа",
  "Harvest as": "Преузми као",
  "Harvest source validation": "Валидација извора харвестерa",
  "Harvesters": "Харвестери",
  "Heading": "Наслов",
  "Headline": "Наслов",
  "Hits": "Погоци",
  "I'll be informed about its activity": "Добијаћу обавештења о овој активности",
  "Image": "Слика",
  "Image is not tall enough.": "Слика није довољно висока.",
  "Image is not wide enough.": "Слика није довољно широка.",
  "Image is too tall.": "Слика је превисока.",
  "Image is too wide.": "Слика је превише широка.",
  "Include": "Укључи",
  "Initialized": "Покренуто",
  "Initializing": "Иницијализација",
  "Insert Hyperlink": "Уметните хипервезу",
  "Insert Image Hyperlink": "Уметните хипервезу слике",
  "Invalid API request:": "Неисправан API захтев:",
  "It gives you an overview of what will be useful for contributors to find and reuse your data.": "То вам даје преглед тога шта ће бити корисно за сараднике како би пронашли и употребили ваше податке.",
  "It means that this source will be harvested regulary.": "То значи да ће се подаци из овог извора редовно преузимати.",
  "It will not be possible to recover this profile once deleted.": "Подаци ће бити трајно обрисани.",
  "It will not be possible to recover your profile once deleted.": "Подаци ће бити трајно обрисани.",
  "Italic": "Курзив",
  "Items": "Ставке",
  "Jobs": "Задаци",
  "Last name": "Презиме",
  "Last page": "Последња страница",
  "Last run": "Последње покретање",
  "Last update": "Последње ажурирање",
  "License": "Лиценца",
  "List": "Листа",
  "Loading": "Учитавање",
  "Location": "Локација",
  "Logo": "Логотип",
  "Maybe you should find yours or create your own.": "Пронађи или направи своју.",
  "Me": "Ја",
  "Member added": "Члан је додат",
  "Member deleted": "Члан је избрисан",
  "Member role updated": "Улога члана је ажурирана",
  "Member since": "Члан од",
  "Members": "Чланови",
  "Metadata update": "Ажурирање метаподатака",
  "Mime Type": "MIME тип",
  "Modification": "Модификација",
  "Modified on": "Измењено:",
  "More infos": "Више информација",
  "Name": "Име",
  "Need an update since {days} days.": "Потребно ми је ажурирање од пре {days} дан(а).",
  "New": "Ново",
  "New Post": "Нова објава",
  "New community resource": "Нови ресурс заједнице",
  "New dataset": "Нови скуп података",
  "New harvester": "Нови харвестер",
  "New organization": "Нова организација",
  "New reuse": "Нови пример употребе",
  "New topic": "Нова тема",
  "Next": "Даље",
  "Next page": "Следећа страница",
  "No badge available": "Нема доступних беџева",
  "No community resources": "Нема ресурса заједнице",
  "No data": "Нема података",
  "No dataset": "Не постоји ниједан скуп података",
  "No discussion": "Нема дискусије",
  "No discussion yet? Try to involve users via social networks and/or by email.": "Још увек нема дискусије? Покушајте да укључите кориснике путем друштвених мрежа и/или путем е-поште.",
  "No files to upload.": "Нема датотека за отпремање.",
  "No follower": "Нема пратилаца",
  "No harvester": "Нема харвестера",
  "No item found": "Није пронађена ниједна ставка",
  "No job": "Нема задатка",
  "No job yet": "Још нема ниједног задатка",
  "No members": "Нема чланова",
  "No membership requests": "Нема захтева за чланством",
  "No organization": "Нема ниједне организације",
  "No organization found. You can go to the next step to create your own one.": "Није пронађена ниједна организација. Можете прећи на следећи корак да бисте направили властиту.",
  "No post": "Нема објава",
  "No related datasets": "Нема повезаних скупова података",
  "No related reuses": "Нема повезаних примера употребе",
  "No resources": "Нема ресурса",
  "No result found": "Нема резултата",
  "No reuse": "Нема ниједног примера употребе",
  "No topic": "Нема теме",
  "No user": "Нема корисника",
  "No user found.": "Није пронађен ниједан корисник.",
  "Not scheduled": "Није заказано",
  "Notifications": "Обавештења",
  "Now": "Сада",
  "Number of archived items": "Број архивираних ставки",
  "Number of datasets used": "Број коришћених скупова података",
  "Number of failed items": "Број неуспешних ставки",
  "Number of skipped items": "Број прескочених ставки",
  "Number of succeed items": "Број успешних ставки",
  "Open formats": "Отворени формати",
  "Operation not permitted": "Операција није дозвољена",
  "Organization": "Организација",
  "Organizations": "Организације",
  "Owner": "Власник",
  "Pending": "На чекању",
  "Pending harvester validation for {name}": "Потврда харвестера на чекању за {name}",
  "Pending membership request": "Захтев за чланство на чекању",
  "Pending transfer request": "Захтев за пренос на чекању",
  "Pick the active badges": "Изаберите активне беџеве",
  "Post": "Објава",
  "Post deleted": "Објава је обрисана",
  "Post published": "Објављено",
  "Post unpublished": "Објава је опозвана",
  "Posts": "Блог",
  "Preview": "Преглед",
  "Previous": "Претходно",
  "Previous page": "Претходна страница",
  "Private": "Приватно",
  "Processing": "Обрада",
  "Profile": "Профил",
  "Proposing up-to-date and incremental data makes it possible for reusers to establish datavisualisations on the long term.": "Предлагање ажурних и инкременталних података омогућава корисницима да успоставе визуелизацију података у дужем периоду.",
  "Public": "Јавно",
  "Public profile": "Јавни профил",
  "Publication": "Објављено",
  "Publication date": "Датум објављивања",
  "Publish": "Објави",
  "Publish a new dataset": "Објавите нови скуп података",
  "Publish a new reuse": "Објавите нови пример употребе",
  "Publish as": "Објављено као",
  "Publish as an organization": "Објави као организација",
  "Publish by": "Објавио:",
  "Publish in your own name": "Објави као лично своје",
  "Publish some content": "Објавите неки садржај",
  "Published on": "Објављено:",
  "Published on {date}": "Објављено: {date}",
  "Quality": "Квалитет",
  "Read the documentation to insert more than one dataset": "Прочитајте документацију да бисте уметнули више од једног скупа података",
  "Reason": "Разлог",
  "Refuse": "Одбиј",
  "Refused": "Одбијено",
  "Regenerate": "Регенерација",
  "Reject": "Одбаци",
  "Remote ID": "Даљински ID",
  "Remove": "Уклони",
  "Reorder": "Преуреди",
  "Replace the file": "Замени фајл",
  "Resize your thumbnail": "Промена величине сличице",
  "Resources": "Ресурси",
  "Resources count": "Број ресурса",
  "Response sent": "Одговор је послат",
  "Restore": "Поврати",
  "Retry failed - you have reached your file limit.": "Поновни покушај није успео – достигли сте ограничење броја датотека.",
  "Reuse": "Пример употребе",
  "Reuses": "Примери употребе",
  "Reuses about your data (including your organizations)": "Примери употребе ваших података (укључујући и ваше организације)",
  "Role": "Улога",
  "Role \"{role}\" is required": "\"{role}\" рола неопходна ",
  "Roles": "Улоге",
  "Save": "Сачувај",
  "Save and continue": "Сачувај и настави",
  "Schedule": "Распоред",
  "Scheduling": "Заказивање",
  "Schema": "Шема",
  "Score:": "Оцена:",
  "Search": "Претрага",
  "Search an user": "Претрага корисника",
  "Search in your data: {q}": "Претражите у вашим подацима: {q}",
  "See in the administration": "Погледајте у администрацији",
  "See on the site": "Погледајте на сајту",
  "Select a file from your computer": "Изаберите датотеку са рачунара",
  "Semidaily": "Два пута дневно",
  "Share": "Подели",
  "Sign out": "Одјавите се",
  "Since": "Од",
  "Site": "Сајт",
  "Size": "Величина",
  "Skipped": "Прескочено",
  "Some of your resources may have broken links or temporary unavailability. Try to fix it as fast as you can (see the list below).": "Неки од ваших ресурса можда имају раскинуте везе или привремено нису доступни. Покушајте да то решите што пре (погледајте листу у наставку).",
  "Spatial coverage": "Просторна покривеност",
  "Spatial granularity": "Просторна грануларност",
  "Stars": "Звездице",
  "Start": "Почетак",
  "Start a discussion": "Започни дискусију",
  "Start a new discussion": "Започни нову дискусију",
  "Start typing to find your organization.": "Почните да куцате да бисте пронашли своју организацију.",
  "Start typing to find your user.": "Почните да куцате да бисте пронашли корисника.",
  "Started": "Започето",
  "Started at": "Започето у",
  "Starting a new discussion thread": "Започни дискусију у новој нити",
  "Status": "Статус",
  "Submit your comment": "Објави свој коментар",
  "Summary": "Резиме",
  "System": "Систем",
  "Tags": "Ознаке",
  "Tags helps your reusers to find your resources, that is very important to make your dataset popular.": "Ознаке помажу корисницима да пронађу ваше ресурсе, што је веома важно да би ваш скуп података постао популаран.",
  "Temporal coverage": "Временска покривеност",
  "Territorial coverage": "Територијална покривеност",
  "Territorial coverage granularity": "Грануларност територијалне покривености",
  "Territories": "Територије",
  "That is great!": "То је сјајно!",
  "The aim of that box is to help you improve the quality of the (meta)data associated to your dataset.": "Циљ овог поља јесте да вам помогне да унапредите квалитет (мета)података који су повезани са вашим скупом података.",
  "The availability of your distant resources (if any) is crucial for reusers. They trust you for the reliability of these data both in terms of reachability and ease of access.": "Доступност удаљених ресурса (ако постоје) од кључног је значаја за оне који користе ваше податке. Они имају поверења у поузданост тих података, како у смислу доступности тако и кад је реч о једноставности приступа.",
  "The error identifier is {id}": "Идентификатор грешке је {id}",
  "The files are being uploaded, if you leave now the upload will be canceled.": "Датотеке се отпремају. Ако сада прекинете процес, отпремање ће бити отказано.",
  "The harvester has been updated.": "Харвестер ажуриран.",
  "The identity of this public service is certified by %(certifier)s": "Идентитет овог јавног сервиса је сертификован од %(certifier)s",
  "The open data community enjoy using files in open formats that can be manipulated easily through open software and tools. Make sure you publish your data at least in formats different from XLS, DOC and PDF.": "Заједница корисника отворених података користи датотеке у отвореним форматима којима се може лако манипулисати кроз отворени софтвер и алатке. Уверите се да сте податке објавили барем у форматима који нису HLS, DOC и PDF.",
  "The recipient need to accept the transfer in order to complete it.": "Прималац мора да прихвати пренос како би га довршио.",
  "The response has been sent to the requester.": "Одговор је послат подносиоцу захтева.",
  "The user {fullname} has been successfully deleted": "Корисник {fullname} је успешно обрисан",
  "This harvest source has not been validated": "Овај извор преузимања није потврђен",
  "This is a cron expressions. See {url} for more details.": "Види {url} за више детаља.",
  "This item has been deleted": "Ова ставка је обрисана",
  "This key is needed if you want to use the API.": "Овај кључ је неопходан ако желите да користите API.",
  "This resource is hosted on an external server": "Овај ресурс се налази на екстерном серверу",
  "This resource is hosted on our servers": "Овај ресурс се налази на нашим серверима",
  "This widget allows you to generate or regenerate your API Key.": "Овај виџет вам омогућава да генеришете или регенеришете API кључ.",
  "Title": "Наслов",
  "Today": "Данас",
  "Too many items ({netItems}) would be uploaded. Item limit is {itemLimit}.": "Било би отпремљено превише ставки ({netItems}). Максимални број ставки је {itemLimit}.",
  "Topic": "Тема",
  "Topic deleted": "Тема је обрисана",
  "Topics": "Теме",
  "Traffic": "Саобраћај",
  "Transfer": "Пренос",
  "Transfer request": "Захтев за пренос",
  "Transfer requested": "Затражен је пренос",
  "Transfer to": "Пренос у",
  "Try to be as descriptive as you can for your resources (how you use it yourself, which edge cases you solved, what data is missing and so on).": "Покушајте да дате што бољи опис ресурса (како их ви користите, које граничне случајеве сте решили, који подаци недостају и тако даље).",
  "Type": "Тип",
  "Type an user name": "Откуцајте корисничко име",
  "Type your comment": "Откуцајте коментар",
  "URL": "URL",
  "URL/Link": "URL/веза",
  "Unfollow": "Отпрати",
  "Unique visitors": "Јединствени посетиоци",
  "Unknown error while communicating with the server": "Непозната грешка у комуникацији са сервером",
  "Unpublish": "Опозови објаву",
  "Unrecoverable error - this browser does not permit file uploading of any kind due to serious bugs in iOS8 Safari. Please use iOS8 Chrome until Apple fixes these issues.": "Дошло је до непоправљиве грешке – овај претраживач не дозвољава отпремање датотека било које врсте због озбиљних грешака у програму iOS8 Safari. Користите iOS8 Chrome док Apple не реши те проблеме.",
  "Unschedule": "Откажи заказано",
  "Unsupported ISO-8601 date format": "Неподржани ISO 8601 формат датума",
  "Unsupported ISO-8601 date-time format": "Неподржани ISO-8601 формат датума и времена",
  "Up-to-date": "Ажурно",
  "Update frequency": "Фреквенција ажурирања",
  "Upload an image": "Објављивање слике",
  "Upload error on {name}": "Грешка при отпремању за {name}",
  "Upload your organization logo": "Отпремите логотип своје организације",
  "Upload your post image": "Отпремите слику објаве",
  "Upload your reuse thumbnail": "Отпремите сличицу примера употребе",
  "User": "Корисник",
  "User Image": "Слика корисника",
  "User has been updated.": "Корисник је ажуриран.",
  "Users": "Корисници",
  "Validate": "Потврдите",
  "Validation": "Валидација",
  "Verification": "Потврда",
  "Views": "Прикази",
  "Website": "Веб-сајт",
  "Why not add some more?": "Зашто не бисте додали још?",
  "Why not improve it?": "Зашто га не бисте побољшали?",
  "Write your post": "Напиши објаву",
  "Write your topic": "Напиши тему",
  "Writing": "Објава",
  "You are about to delete the profile of the user {fullname}.": "Брисање профила корисника {fullname}.",
  "You are about to delete this dataset": "Намеравате да избришете овај скуп података",
  "You are about to delete this discussion": "Намеравате да избришете ову дискусију",
  "You are about to delete this harvest source": "Намеравате да избришете овај извор преузимања",
  "You are about to delete this organization": "Намеравате да избришете ову организацију",
  "You are about to delete this post": "Обрисаћете ову објаву",
  "You are about to delete this resource": "Намеравате да избришете овај ресурс",
  "You are about to delete this reuse": "Намеравате да избришете овај пример употребе",
  "You are about to delete this topic": "Обрисаћете ову тему",
  "You are about to delete your profile.": "Брисање вашег профила",
  "You are about to publish this post": "Намеравате ово да објавите",
  "You are about to restore this dataset": "Намеравате да поништите брисање овог скупа података",
  "You are about to restore this organization": "Намеравате да поништите брисање ове организације",
  "You are about to restore this reuse": "Намеравате да поништите брисање овог примера употребе",
  "You are about to unpublish this post": "Намеравате да опозовете објаву",
  "You are about to unschedule this harvest source": "Отказивање заказаног жетелаца",
  "You are about to validate (or not) this harvest source.": "Намеравате да потврдите (или не потврдите) овај извор преузимања.",
  "You are currently involved in all discussions!": "Тренутно сте укључени у све дискусије!",
  "You are going to send a transfer request for": "Намеравате да пошаљете захтев за пренос за",
  "You are not a member of any organization.": "Ви нисте члан нити једне организације",
  "You are not allowed to perform this operation": "Немате потребне дозволе да извршите ову операцију",
  "You can also link to an existing remote file or URL by clicking here.": "Такође можете повезати екстерни фајл или URL, кликните овде.",
  "You can now either publish a dataset or a reuse.": "Сада можете да објавите скуп података или пример употребе.",
  "You currently have no frequency set for that dataset, is that pertinent?": "Тренутно немате подешену фреквенцију за тај скуп података. Да ли је то релевантно?",
  "You currently have some open formats!": "Тренутно имате неке податке у отвореном формату!",
  "You currently set your frequency to {frequency}.": "Тренутно сте поставили фреквенцију на {frequency}.",
  "You don't have generated an API KEY yet.": "Још увек нисте генерисали API кључ.",
  "You have some untreated discussion threads. Why do not you give it a look below?": "Имате неке нерешене нити дискусије. Зашто их не бисте погледали у наставку?",
  "You need to be logged in to comment.": "Морате бити пријављени да бисте коментарисали.",
  "You need to be logged in to follow.": "Морате бити пријављени да бисте пратили.",
  "You need to be logged in to start a discussion.": "Морате бити улоговани да би стартовали дискусију.",
  "You only have closed formats or no format defined. Can you fill the format info or export some resources in an open format?": "Тренутно имате само податке у затвореном или недефинисаном формату. Можете ли да попуните информације о формату или да објавите неке ресурсе у отвореном формату?",
  "You'll be notified on approval (or refusal)": "Бићете обавештени о одобрењу (или одбијању)",
  "You're about to start a new discussion thread. Make sure that a thread about the same topic doesn't exist yet just above.": "Креирате нову нит на дискусији. Проверите да ли слична нит већ постоји.",
  "Your community resource has been created": "Ресурс заједнице је направљен",
  "Your dataset has been created": "Скуп података је направљен",
  "Your dataset has been updated.": "Ваш скуп података је ажуриран.",
  "Your description has currently {description_length} caracters.": "Ваш опис тренутно има {description_length} знак(ов)а.",
  "Your harvester has been created": "Харвестер је направљен",
  "Your harvester is now pending for team review.": "Харвестер сада чека на преглед тима.",
  "Your harvester is ready": "Харвестер је спреман",
  "Your organization has been created": "Ваша организација је направљена",
  "Your organization has been updated.": "Ваша организација је ажурирана.",
  "Your post has been updated.": "Ваша објава је ажурирана.",
  "Your profile has been updated.": "Ваш профил је ажуриран",
  "Your resource has been added.": "Ваш ресурс је додат.",
  "Your resource has been deleted.": "Ваш ресурс је обрисан.",
  "Your resource has been updated.": "Ваш ресурс је ажуриран.",
  "Your reuse has been created": "Пример употребе је направљен",
  "Your reuse has been updated.": "Ваш пример употребе је ажуриран.",
  "Your topic has been updated.": "Ваша тема је ажурирана.",
  "and": "и",
  "by": "од",
  "change": "промена",
  "closed discussion": "затворена дискусија",
  "emphasized text": "наглашени текст",
  "enter image description here": "овде унесите опис слике",
  "enter image title here": "овде унесите наслов слике",
  "enter link description here": "овде унесите опис везе",
  "followed organization": "прати организацију",
  "heading text": "текст наслова",
  "last response": "последњи одговор",
  "list text here": "текст листе овде",
  "messages": "порукe",
  "on": "на",
  "or": "или",
  "sort by": "",
  "strong text": "јак текст",
  "to": "до",
  "topic creation": "креирање теме",
  "valid-creditcard": "valid-creditcard",
  "valid-date": "valid-date",
  "valid-date-iso": "valid-date-iso",
  "valid-digits": "valid-digits",
  "valid-email": "valid-email",
  "valid-equal-to": "valid-equal-to",
  "valid-max": "valid-max",
  "valid-maxlength": "valid-maxlength",
  "valid-min": "valid-min",
  "valid-minlength": "valid-minlength",
  "valid-number": "valid-number",
  "valid-range": "valid-range",
  "valid-range-length": "valid-range-length",
  "valid-remote": "valid-remote",
  "valid-required": "valid-required",
  "valid-url": "valid-url",
  "{count} New Requests": "Нови захтеви: {count}",
  "{file} has an invalid extension. Valid extension(s): {extensions}.": "{file} има неважећу ознаку типа датотеке. Важеће ознаке типа датотеке: {extensions}.",
  "{file} is empty, please select files again without it.": "Датотека {file} је празна. Поново изаберите датотеке без ње.",
  "{file} is too large, maximum file size is {sizeLimit}.": "Датотека {file} је превелика; максимална величина датотеке је {sizeLimit}.",
  "{file} is too small, minimum file size is {minSizeLimit}.": "Датотека {file} је премала; минимална величина датотеке је {minSizeLimit}.",
  "{name} has been scheduled on {schedule}": "{name} је заказано за {schedule}",
  "{name} has been unscheduled": "{name} отказан",
  "{start} to {end}": "од {start} до {end}",
  "{user} is not a member of this organization anymore": "{user} више није члан ове организације",
  "{user} is now {role} of this organization": "{user} је сада {role} у овој организацији",
  "An error occurred while featuring this subject.": "",
  "Preview of resource X": "Преглед у ресурса X",
  "Edit resource": "Измените ресурс",
  "downloads": "преузимања",
  "Nameless resource": "Ресурс без имена",
  "Available": "Доступно",
  "Unavailable": "Несоступно",
  "See more details": "Видите још детаља",
  "Copy permalink to clipboard": "Прекопирајте пермалинк у клипборд",
  "Resource link": "Веза ресурса",
  "Download resource": "Преузмите ресурс",
  "Permalink": "Пермалинк",
  "MIME Type": "МИМЕ тип",
  "An error occurred while fetching resources": "Дошло је до грешке код преузимања ресурса",
  "See schema": "Видите шему",
  "Associated schema": "Придружена шема",
  "This resource is associated to the schema ": "Овај ресурс је придружен шеми ",
  "this means that the producer reports that it adheres to the specification.": "ово значи да извор изјављује да се придржава спецификације.",
  "Documentation": "Документација",
  "You can view the schema documentation, discover some context and recommendations for data producers.": "Можете видети документацију шеме, открити контекст и препоруке за изворе.",
  "Read documentation": "Прочитајте документацију",
  "Resource validation based on a schema is a way to verify that the resource complies to the schema it is supposed to abide by. In case of errors, a validation report shows the errors found: wrongly named columns, non conform values, etc.": "Валидација ресурса заснована на шеми је начин да се провери да ли је ресурс усклађен са шемом коју би требало да поштује. У случају грешака, извештај о валидацији показује пронађене грешке: погрешно именоване колоне, неусаглашене вредности, итд.",
  "data.gouv.fr allows you to validate your files based on a schema and correct the possible errors.": "овај портал вам дозвољава валидацију ваших фајлова на основу шеме и исправку евентуалних грешака.",
  "Validate resource": "Валидација ресурса",
  "Others resources": "Остали ресурси",
  "You can specify that a resource complies to a schema on your producer dashboard. Other resources complying with the schema are available on the platform.": "Можете навести да је ресурс усклађен са шемом на контролној табли вашег извора. Други ресурси који су у складу са шемом доступни су на платформи.",
  "See dataset linked to this schema": "Видите скуп података повезан са шемом",
  "About schemas": "О шемама",
  "Data schemas allow to describe data models : what are the fields, how is data represented, what are the possible values. Discover how schemas improve data quality and use cases on ": "Шеме података омогућавају описивање модела података: која су поља, како су подаци представљени, које су могуће вредности. Откријте како шеме побољшавају квалитет података и случајеве употребе над ",
  "resources": "ресурса",
  "reuses": "употреба",
  "favourites": "подржавања",
  "Admin": "Админ",
  "Reply to the discussion": "Одговорите на дискусију",
  "Reply as": "Одговорите као",
  "Submit": "Поднесите",
  "Error sending response": "Грешка код слања одговора",
  "Discussion closed": "Дискусија завршена",
  "Copy permalink": "Копирајте пермалинк",
  "Reply": "Одговор",
  "The discussion was closed by": "Дискусија је затворена од стране",
  "New discussion": "Нова дискусија",
  "Message": "Порука",
  "Sort discussions by": "Распореди дискусије по",
  "You are seeing a specific discussion about this dataset": "Видите посебне дискусије о овом скупу података",
  "See all discussions about this dataset": "Видите све дискусије о овом скупу података",
  "Discussion creation": "Креирање дискусије",
  "Last reply": "Последњи одговор",
  "An error occurred while fetching discussions": "Дошло је до грешке код дохватања дискусија",
  "An error occurred while fetching the discussion ": "Дошло је до грешке код дохватања дискусије",
  "An error occurred while creating the discussion ": "Дошло је до грешке код креирања дискусије",
  "Ask to join the organization as a producer": "Придружи се као извор",
  "You can add some details here for your membership request": "Можете додати детаље овде за ваш захтев за чланство",
  "A request has been sent to the administrators": "Захтев је послат администраторима",
  "Error while requesting membership": "Грешка код захтева за чланство",
  "Page": "Страна",
  "There are no results for your search": "Нема резултата за вашу претрагу",
  "from": "од",
  "Search...": "Претрага...",
  "Search for data...": "Претрага података...",
  "Search reuses": "Примери употребе",
  "Search filters": "Филтер претраге",
  "Search an organization...": "Претрага организација...",
  "Search a tag...": "Претрага тагова...",
  "Licenses": "Лиценце",
  "Search a license...": "Претрага лицнци...",
  "Formats": "Формати",
  "Search a format...": "Претрага формата...",
  "Geographic area": "Географска област",
  "Search a geographic area...": "Претрага географске области",
  "Territorial granularity": "Територијална грануларност",
  "Search a granularity...": "Претрага грануларности...",
  "Reset filters": "Ресет филтера",
  "No dataset matching your query": "Нема скупа података који одговарају упиту",
  "You can try to reset the filters to expand your search.": "Можете да ресетујете филтере ради проширења претраге",
  "Error getting search results.": "Грешка код добијања резултата претраге",
  "Search for data, reuses, contributions...": "Претрага података, примера употреба, доприноса... ",
  "Search all datasets": "Претрага свих скупова података",
  "Datasets are collections of data, i.e. structured information, easily readable by a machine.": "Скупови података су структуиране информације које машине лако читају.",
  "See all datasets": "Видите све скупове података",
  "Search in datasets": "Претрага у скуповима података",
  "Search in reuses": "Претрага  у примерима употреба",
  "Reuses refer to the use of data for an other purpose than the one they were produced for.": "Примери употреба се односе на коришћење података у другачију сврху од оне за коју су створени.",
  "See the reuses": "Видите примере употребе",
  "No reuse matching your query": "Нема примера употребе који одговарају вашем упиту",
  "No results found.": "Нема пронађених резултата.",
  "Unfeature this content": "Прекините истакнутост овог садржаја",
  "remove from favorites": "уклоните из омиљнених",
  "add to favorites": "додајте у омиљене",
  "Read less": "Читајте мање",
  "Read more": "Читајте више",
  "Created date asc": "Датум креирања навише",
  "Created date desc": "Датум креирања",
  "Last modified asc": "Датум последње измене навише",
  "Last modified desc": "Датум последње измене",
  "Title asc": "Наслов навише",
  "Title desc": "Наслов наниже",
  "Followers asc": "Пратиоци навише",
  "Followers desc": "Број пратиоца",
  "Reuses asc": "Примери употребе навише",
  "Reuses desc": "Примери употребе",
  "Download datasets": "Преузми податкe",
  "Download resources": "Преузми ресурсе",
  "Documents": "Документа",
  "Documents and instructions": "Документа и упутства",
  "Law and by laws": "Закон и подзаконска акта",
  "Instructions": "Упутства",
  "Добродошли на портал отворених података": "Dobrodošli na portal otvorenih podataka",
  "Sort by": "",
  "Search by sort...": "Распоред према..."
}